<template>
  <div class="tag">
    <slot />
  </div>
</template>

<script>
export default {
  mounted() {
    this.$el.parentNode.style.position = 'relative'
  }
}
</script>

<style>
.tag {
  position: absolute;
  top: 6px;
  right: -1px;
  height: 12px;
  padding: 0 3.5px;
  border-radius: 6px 6px 6px 0;
  background: #ff3826;
  color: #fff;
  font-size: 8px;
  line-height: 12px;
  text-align: center;
}
</style>
